/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
 export const CONTACT_ANOMALIES_TAB_DATA = 'CONTACT_ANOMALIES_TAB_DATA';
 export const GET_TAB_VALUE="GET_TAB_VALUE";
 export const GET_SEARCH_CONTACT_ANOMALIES_BY_CRITERIA_LIST = "GET_SEARCH_CONTACT_ANOMALIES_BY_CRITERIA_LIST";
 export const GET_SEARCH_COPY_CONTACT_ANOMALIES_BY_CRITERIA_LIST = "GET_SEARCH_COPY_CONTACT_ANOMALIES_BY_CRITERIA_LIST";
 export const GET_SEARCH_CONTRACT_BY_CRITERIA_LIST = "GET_SEARCH_CONTRACT_BY_CRITERIA_LIST";
 export const GET_SEARCH_MFG_BY_CRITERIA_LIST = "GET_SEARCH_MFG_BY_CRITERIA_LIST";
 export const GET_SEARCH_CODE_VALUE_LONG_DESC = "GET_SEARCH_CODE_VALUE_LONG_DESC";
 export const SAVE_CONTACT= "SAVE_CONTACT"
 export const HANDLE_SUCCESS_MESSAGE_FOR_CONTACT_ANOMALIES = "HANDLE_SUCCESS_MESSAGE_FOR_CONTACT_ANOMALIES";
 export const HANDLE_ERROR_MSG_CA = "HANDLE_ERROR_MSG_CA";
 export const INPUT_FIELD_VALUE_ACTION = "INPUT_FIELD_VALUE_ACTION";
 export const MULTIPLE_SAVE_DATA = "MULTIPLE_SAVE_DATA";